import styled from 'styled-components'
import colors from '../../../../configuration/colors'
import EditIcon from '../../../../static/images/icons/edit_icon.svg'
import { H5 } from '../../../styled/typography/typography'

export const Container = styled.div`
  position: relative;
  width: ${props => props.journey && props.isEditing ? 'calc(100% + 44px)' : '100%'};
  padding: ${props => props.journey ? '13px 22px' : '17px ' + props.paddingLR + 'px'} ;
  margin-bottom: ${props =>
    props.marginBottom ? props.marginBottom + 'px' : 0};
  background: ${props => 
          props.journey && props.isEditing 
            ? props.theme.mentorBackground 
            : props.background || props.theme.mentorBackground };
  border-top: ${props => props.isEditing && props.journey ? '1px solid #DEDFE0' : ''};
  border-bottom: ${props => props.isEditing && props.journey ? '1px solid #DEDFE0' : ''};
  margin-left: ${props => props.journey ? '-22px' : '0'};
  margin-right: ${props => props.journey ? '-22px' : '0'};

  .delete-mentor-guidance {
    display: none;
  }

  &:hover {
    .delete-mentor-guidance {
      display: block;
    }
  }
`

export const PencilIcon = styled.img.attrs({
  src: EditIcon
})`
  width: 13px;
  height: 13px;
  margin-left: 14px;
  cursor: pointer;
`

export const EditorWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 14px 17px 30px;
  margin-top: 12px;
  min-height: 94px;
  background: ${colors.white};
  border-radius: 7px;
  border: 1px solid ${colors.rock};
  z-index: ${props => (props.focus ? '20' : '0')};

  .DraftEditor-root {
    cursor: text;
  }
`

export const DeleteButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: -16px;
  left: ${props => props.leftOffset}px;
  right: -${props => props.rightOffset}px;
  height: 100%;
  width: ${props => props.rightOffset + 45}px;
`

export const CancelButton = styled(H5).attrs({
  as: 'button'
})`
  margin-right: 20px;
  background: none;
  border: none;
`

export const EditGuidance = styled.div`
  max-width: 720px;
  //background-color: #F5F5F5;
`
